// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.photos.RentalManagerUserPropertyPhotoWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UpdatePropertyPhotoRankRequestWebDto,
  UserPropertyFloorPlanPhotoUploadRequestWebDto,
  UserPropertyPhotoGenerateUploadUrlRequestWebDto,
  UserPropertyPhotoPollPhotoIdsResponseWebDto,
  UserPropertyPhotoUploadResponseWebDto,
} from '../..';

interface CaptionParams {
  caption?: string;
  photoId: string;
}
interface DeleteParams {
  photoId: string;
}
interface PollPhotoIdsParams {
  listingAlias: ListingAlias;
}
interface RankParams {
  listingAlias: ListingAlias;
}
interface UploadParams {
  listingAlias: ListingAlias;
  sourceUrl?: string;
}

export const RentalManagerUserPropertyPhotoWebApiHandler_caption_Path = '/api/web/v1/users/properties/photos/caption';

/**
 * Update a photo caption
 * @deprecated
 */
export const RentalManagerUserPropertyPhotoWebApiHandler_caption = (getParams: CaptionParams, client = getClient()) => {
  return httpFrontEndRequest<CaptionParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyPhotoWebApiHandler_caption_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyPhotoWebApiHandler_delete_Path = '/api/web/v1/users/properties/photos/delete';

/**
 * Delete a property photo
 * @deprecated
 */
export const RentalManagerUserPropertyPhotoWebApiHandler_delete = (getParams: DeleteParams, client = getClient()) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyPhotoWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_Path =
  '/api/web/v1/users/properties/photos/generateUploadUrl';

/**
 * Generate a time-limited photo upload URL for the QR-code phone upload flow
 */
export const RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl = (
  postData: UserPropertyPhotoGenerateUploadUrlRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyPhotoGenerateUploadUrlRequestWebDto, string>(
    {
      endpoint: RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_Path =
  '/api/web/v1/users/properties/photos/pollPhotoIds';

/**
 * List the encoded photo ids of a listing, for the QR upload flow to poll for changes
 */
export const RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds = (
  getParams: PollPhotoIdsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PollPhotoIdsParams, never, UserPropertyPhotoPollPhotoIdsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyPhotoWebApiHandler_rank_Path = '/api/web/v1/users/properties/photos/rank';

/**
 * Update the rank of photos
 * @deprecated
 */
export const RentalManagerUserPropertyPhotoWebApiHandler_rank = (
  getParams: RankParams,
  postData: UpdatePropertyPhotoRankRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<RankParams, UpdatePropertyPhotoRankRequestWebDto, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyPhotoWebApiHandler_rank_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyPhotoWebApiHandler_upload_Path = '/api/web/v1/users/properties/photos/upload';

/**
 * Upload a property photo
 */
export const RentalManagerUserPropertyPhotoWebApiHandler_upload = (
  getParams: UploadParams,
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    UploadParams,
    UserPropertyFloorPlanPhotoUploadRequestWebDto,
    UserPropertyPhotoUploadResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyPhotoWebApiHandler_upload_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
      isFormData: true,
    },
    client,
  );
};
